import { Guid } from "@/Common/Models/Guid";

class LicenseDto {
    public LicenseNumber: string = "";
    public EndDate: string = "";
    public Suffix: string = "";
    public ShouldApplySuffix: boolean = false;
    public EmployeeContactFacetId: Guid;

    constructor(fields?: Partial<LicenseDto>) {
        Object.assign(this, fields);
    }
}

export { LicenseDto };
